
import { createContext,useState } from "react";  

const AuthContext = createContext(); 

export const AuthProvider = ({children})=>{

    const [auth, setAuth] = useState({}); 
     // const [auth, setAuth] = useState({roles:["admin"]}); 
    // const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist")) || false);
    const [persist, setPersist] = useState(false);

    return(
        <AuthContext.Provider value={{auth,setAuth}}> 

                  {children}

            </AuthContext.Provider>

    )
             
}


export default AuthContext; 

